import request from '../http/axios'
import Vue from 'vue'

function reuseDot (params, data) {
  request({
    url: `/common/user-behavior-record/${params.pageName}/${params.action}`,
    method: 'POST',
    data: {
      // extInfo
      extInfo: params.extInfo ? JSON.stringify(params.extInfo) : undefined,
      // userRandomKey
      userRandomKey: localStorage.getItem('userRandomKey'),
      // adid
      adid: localStorage.getItem('adid') || null
    }
  })
}
Vue.prototype.$reuseDot = reuseDot
export default {
  reuseDot
}
